import { use } from 'react';
import TailwindContext from '../tailwind.context';
const useActiveBreakpoints = () => {
    const { activeBreakpoints } = use(TailwindContext);
    return {
        ...activeBreakpoints
    };
};
export default useActiveBreakpoints;
